"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlayabilityStartDateProperty = exports.playabilityStartDatePropertyDefinition = void 0;
exports.playabilityStartDatePropertyDefinition = {
    view: { label: 'Playability start date' },
    constraints: [],
    type: 'date-time',
    multiple: false,
    name: 'playability-start-date',
};
const isPlayabilityStartDateProperty = (prop) => {
    return prop.name === exports.playabilityStartDatePropertyDefinition.name;
};
exports.isPlayabilityStartDateProperty = isPlayabilityStartDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxheWFiaWxpdHktc3RhcnQtZGF0ZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3BsYXlhYmlsaXR5LXN0YXJ0LWRhdGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQ0FBc0MsR0FBRztJQUNwRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsd0JBQXdCLEVBQUU7SUFDekMsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSx3QkFBd0I7Q0FDQyxDQUFBO0FBSTFCLE1BQU0sOEJBQThCLEdBQUcsQ0FBQyxJQUFrQixFQUF3QyxFQUFFO0lBQ3pHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw4Q0FBc0MsQ0FBQyxJQUFJLENBQUE7QUFDbEUsQ0FBQyxDQUFBO0FBRlksUUFBQSw4QkFBOEIsa0NBRTFDIn0=